import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Draft' },
    { value: 2, label: 'Posted' },
    { value: 3, label: 'Deleted' },
    { value: 4, label: 'Voided' },
  ],
});
